<!-- Bouton Retour à l’accueil -->
<dsd-link-action variant="return" class="dsd-mb-md">
  <a [href]="urlAccueil"
    ><span class="dsd-sr-only">{{ 'bouton.horsEcran.allerA' | translate }}&nbsp;</span
    >{{ 'bouton.retourAccueil' | translate }}</a
  >
</dsd-link-action>
